module.exports = __webpack_public_path__ + "9613f7dd938b8828a541de4fb626d6f0.png";